import * as Api from '@/api/api';

const api = process.env.REACT_APP_PLAN_BUILDER_API;

const path = '/api/v1/histories';

export const filterEditHistories = Api.post({ path, api });

export const getHistoryOptions = Api.get({ path: `${path}/options`, api });
